import { Helmet } from "react-helmet-async";
import { ProgramCard } from "../components/ProgramCard";
import { programs as staticPrograms } from "../data/programs";
import { useProgramas } from "../hooks/useCms";
import { programaCmsToCard } from "../lib/adapters";

export function ProgramasPage() {
  const { data: cmsProgramas } = useProgramas();
  const programs =
    cmsProgramas && cmsProgramas.length > 0
      ? cmsProgramas.map(programaCmsToCard)
      : staticPrograms;

  return (
    <>
      <Helmet>
        <title>Programas — Campus EMJC</title>
      </Helmet>
      <section className="container-emjc py-20">
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-orange-deep">
          Programas
        </p>
        <h1 className="mt-2 max-w-3xl font-display text-5xl font-semibold leading-tight">
          Cuatro maneras de descubrir la ciencia.
        </h1>
        <p className="mt-5 max-w-2xl text-lg text-gray-700">
          Desde campamentos urbanos en julio hasta una conferencia con cata de vino y jazz: nuestro
          programa cubre todas las edades y todos los apetitos científicos.
        </p>
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {programs.map((p) => (
            <ProgramCard key={p.slug} program={p} />
          ))}
        </div>
      </section>
    </>
  );
}
